(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8735],{

/***/ 24337:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hizmetler/[slug]",
      function () {
        return __webpack_require__(55741);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 24988:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32852);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_common_BBadge__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24800);
/* harmony import */ var components_common_BImage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69327);
/* harmony import */ var components_common_CurrencyText__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95269);
/* harmony import */ var hooks_useBreakpoints__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43617);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88082);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26420);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(32466);
/* harmony import */ var styles_ExperienceCard_module_css__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(97890);
/* harmony import */ var styles_ExperienceCard_module_css__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(styles_ExperienceCard_module_css__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(48063);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(30933);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(68770);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(10520);
/* harmony import */ var components_common_Favourited__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(76417);
/* harmony import */ var components_common_RatingStar__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(31399);
/* harmony import */ var utils_experience_experienceDuration_util__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(70379);
/* harmony import */ var states_useFavorite_store__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(80810);
/* harmony import */ var hooks_useFavorite__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(61356);
/* harmony import */ var states_useUserState__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(13253);
/* harmony import */ var next_translate_routes__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(22742);
/* harmony import */ var next_translate_routes__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(next_translate_routes__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var hooks_usePrevLink__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(3638);
/* harmony import */ var services_AnalyticsService__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(40515);
/* harmony import */ var services_LinkService__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(41824);
/* harmony import */ var hooks_useLocale__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(74021);

























var ExperienceCard = function(param) {
    var containerClass = param.containerClass, _isFirstImagePrioritized = param.isFirstImagePrioritized, isFirstImagePrioritized = _isFirstImagePrioritized === void 0 ? false : _isFirstImagePrioritized, experience = param.experience;
    var ref;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("common").t;
    var asPath = (0,next_translate_routes__WEBPACK_IMPORTED_MODULE_19__.useRouter)().asPath;
    var getPrevLink = (0,hooks_usePrevLink__WEBPACK_IMPORTED_MODULE_20__/* .usePrevLink */ .B)().getPrevLink;
    var isMobile = (0,hooks_useBreakpoints__WEBPACK_IMPORTED_MODULE_5__/* .useBreakpoint */ .G)().isMobile;
    var ref1 = (0,utils_experience_experienceDuration_util__WEBPACK_IMPORTED_MODULE_15__/* .getExperienceDurationByTime */ .x)(experience.duration), hour = ref1.hour, minute = ref1.minute;
    var isUserLoggedIn = (0,states_useUserState__WEBPACK_IMPORTED_MODULE_18__/* .useUserState */ .e)().isUserLoggedIn;
    var getExperienceFavorited = (0,states_useFavorite_store__WEBPACK_IMPORTED_MODULE_16__/* .useFavoriteStore */ .E)().getExperienceFavorited;
    var locale = (0,hooks_useLocale__WEBPACK_IMPORTED_MODULE_23__/* .useLocale */ .b)().locale;
    var analyticsPayload = (0,react__WEBPACK_IMPORTED_MODULE_8__.useMemo)(function() {
        return {
            experienceId: experience.id,
            experienceName: experience.title,
            experienceCategory: experience.type.value,
            regionTrName: experience.regionTRName,
            asPathOfPreviousPage: getPrevLink()
        };
    }, [
        experience,
        asPath
    ]);
    var isFavorited = isUserLoggedIn && (experience.isFavorited || getExperienceFavorited(experience.id));
    var ref2 = (0,hooks_useFavorite__WEBPACK_IMPORTED_MODULE_17__/* .useFavorite */ .s)(isFavorited, undefined, analyticsPayload), isCurrentFavorited = ref2.isCurrentFavorited, toggleExperienceFavorite = ref2.toggleExperienceFavorite;
    var sendAnalytics = function() {
        services_AnalyticsService__WEBPACK_IMPORTED_MODULE_21__/* .analyticsService.experienceCardClick */ .I.experienceCardClick(analyticsPayload);
    };
    var linkConstructor = function() {
        return services_LinkService__WEBPACK_IMPORTED_MODULE_22__/* .linkService.getExperienceLink */ .k.getExperienceLink(experience.title, experience.id, locale);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "translate-z-0 absolute top-1.5 z-10 flex w-full items-center justify-between px-1.5",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_BBadge__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        className: "shadow-sm shadow-slate-500",
                        variant: "info",
                        contrasted: true,
                        children: t("vehicleImmediatelyReservable")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "transform cursor-pointer rounded-full duration-200 ease-in",
                        onClick: function() {
                            return toggleExperienceFavorite(experience.id);
                        },
                        tabIndex: -1,
                        role: "button",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_Favourited__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                            isCurrentFavorited: isCurrentFavorited
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
                href: linkConstructor(),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((styles_ExperienceCard_module_css__WEBPACK_IMPORTED_MODULE_24___default().container), containerClass),
                    target: isMobile ? "" : "_blank",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (styles_ExperienceCard_module_css__WEBPACK_IMPORTED_MODULE_24___default().image),
                            onClick: sendAnalytics,
                            role: "presentation",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_12__/* .Swiper */ .tq, {
                                modules: [
                                    swiper__WEBPACK_IMPORTED_MODULE_9__/* .Pagination */ .tl
                                ],
                                pagination: {
                                    clickable: true,
                                    dynamicBullets: true,
                                    dynamicMainBullets: 5
                                },
                                spaceBetween: 0,
                                slidesPerView: 1,
                                children: experience.images.slice(0, 10).map(function(image, idx) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_12__/* .SwiperSlide */ .o5, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_BImage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                            src: image,
                                            height: 240,
                                            width: 300,
                                            alt: "".concat(experience.title, "-idx"),
                                            className: "object-cover",
                                            priority: isFirstImagePrioritized && idx === 0
                                        })
                                    }, "".concat(image, "-").concat(idx));
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "mb-1 flex items-start justify-between",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "text-sm",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "text-base font-medium",
                                                children: experience.title
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "flex shrink-0 items-center",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_RatingStar__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                                commentCount: experience.reviewCount || 0,
                                                rating: experience.overallRating || 0,
                                                size: 16,
                                                small: true
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "text-sm text-slate-500",
                                    children: [
                                        "Tur s\xfcresi: ",
                                        hour ? "".concat(hour, " ").concat(t("experience.hour"), " ") : "",
                                        minute ? "".concat(minute, " ").concat(t("experience.minute"), " ") : ""
                                    ]
                                }),
                                !((ref = experience.sessionSummary) === null || ref === void 0 ? void 0 : ref.price) ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_CurrencyText__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                            className: "text-lg",
                                            price: experience.sessionSummary.price.amount,
                                            currency: experience.sessionSummary.price.currency
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                            className: "text-lg text-slate-500",
                                            children: [
                                                "/",
                                                t("units.headCount")
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ExperienceCard);


/***/ }),

/***/ 75765:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85157);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18098);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32466);
/* harmony import */ var components_common_BButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87114);
/* harmony import */ var components_Experience_ExperienceCard__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24988);
/* harmony import */ var components_Vehicle_VehicleCard__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95614);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88082);








function isVehicle(vehicle) {
    return "vehicleId" in vehicle;
}
var VehicleList = function(param) {
    var vehicles = param.vehicles, onPageChange = param.onPageChange, isThereMorePage = param.isThereMorePage, location = param.location;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("common").t;
    var content = vehicles || [];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "grid grid-cols-1 justify-items-center gap-8 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4",
                children: content.map(function(c, i) {
                    return isVehicle(c) ? /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)(components_Vehicle_VehicleCard__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, c), {
                        key: c.vehicleId + "-" + i,
                        location: location,
                        isFirstImagePrioritized: i < 4
                    })) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Experience_ExperienceCard__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        experience: c,
                        isFirstImagePrioritized: i < 4
                    }, c.id + "-" + i);
                })
            }),
            isThereMorePage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_BButton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                className: "mx-auto mt-6 block",
                onClick: onPageChange,
                children: t("seeMore")
            }) : null
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (VehicleList);


/***/ }),

/***/ 73351:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32852);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88082);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32466);
/* harmony import */ var _TranslatedLink__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31468);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67320);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var hooks_useLocale__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74021);







var BBreadcrumb = function(param) {
    var breadcrumbItems = param.breadcrumbItems, wrapperClasses = param.wrapperClasses;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().t;
    var locale = (0,hooks_useLocale__WEBPACK_IMPORTED_MODULE_6__/* .useLocale */ .b)().locale;
    var isCurrent = function(idx) {
        return idx === breadcrumbItems.length - 1;
    };
    var breadcrumbSchema = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return '{"@context": "https://schema.org","@type": "BreadcrumbList","itemListElement": ['.concat(breadcrumbItems.map(function(item, idx) {
            var label = item.isTranslatable ? t(item.label) : item.label;
            var nonQPLink = item.link.split("?")[0];
            var prefixedLink = "https://www.teknevia.com".concat(nonQPLink);
            return '{"@type": "ListItem","position":'.concat(+idx + 1, ',"name":"').concat(label, '","item":"').concat(prefixedLink, '"}');
        }).join(","), "]}");
    }, [
        breadcrumbItems,
        t,
        locale
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("nav", {
        "aria-label": "breadcrumbs",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_5___default()), {
                id: "breadcrumb-schema",
                type: "application/ld+json",
                strategy: "beforeInteractive",
                dangerouslySetInnerHTML: {
                    __html: breadcrumbSchema
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(wrapperClasses, "flex flex-wrap items-center gap-2"),
                children: breadcrumbItems.map(function(item, idx) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("breadcrumb-item text-xs md:text-sm", {
                            "text-primary-600 underline": !isCurrent(idx),
                            "text-black": isCurrent(idx)
                        }),
                        children: isCurrent(idx) ? item.isTranslatable ? t(item.label) : item.label : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TranslatedLink__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            href: item.link,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                children: item.isTranslatable ? t(item.label) : item.label
                            })
                        })
                    }, item.link);
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BBreadcrumb);


/***/ }),

/***/ 54865:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ useBreadcrumbs; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36840);
/* harmony import */ var utils_slugify__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27576);
/* harmony import */ var _useLocale__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74021);
/* harmony import */ var services_LinkService__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41824);
/* harmony import */ var utils_getLocalePrefix__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14211);





function useBreadcrumbs() {
    var locale = (0,_useLocale__WEBPACK_IMPORTED_MODULE_1__/* .useLocale */ .b)().locale;
    var baseBreadcrumbItem = {
        label: "Teknevia",
        link: "/",
        isTranslatable: false
    };
    var defaultBreadcrumbs = [
        baseBreadcrumbItem
    ];
    var generateCategoryLinks = function(category, location) {
        var generatedBreadcrumbsArray = [
            {
                label: category.label,
                link: (0,utils_getLocalePrefix__WEBPACK_IMPORTED_MODULE_3__/* .getLocalePrefix */ .A)(locale) + category.value,
                isTranslatable: false
            }, 
        ];
        if (location) {
            var _loop = function(idx) {
                var labelKey = labelKeys[idx];
                var slugKey = slugKeys[idx];
                var locationLabel = location[labelKey] + " " + category.label;
                var _slugKey;
                var locationSlug = services_LinkService__WEBPACK_IMPORTED_MODULE_2__/* .linkService.generateCategoryLink */ .k.generateCategoryLink({
                    locale: locale,
                    locationSlug: (_slugKey = location[slugKey]) !== null && _slugKey !== void 0 ? _slugKey : (0,utils_slugify__WEBPACK_IMPORTED_MODULE_0__/* .slugifyText */ .E)("".concat(locationLabel)),
                    category: category.value
                });
                var hasAnySameLabel = generatedBreadcrumbsArray.some(function(item) {
                    return item.label === locationLabel;
                });
                if (!hasAnySameLabel) {
                    generatedBreadcrumbsArray.push({
                        label: locationLabel,
                        link: locationSlug,
                        isTranslatable: false
                    });
                }
                if (labelKey.includes(matchType)) {
                    return "break";
                }
            };
            var labelKeys = [
                "cityName",
                "regionName",
                "harborName"
            ];
            var slugKeys = [
                "citySlug",
                "regionSlug",
                "harborSlug"
            ];
            var matchType = location.matchType;
            for(var idx in labelKeys){
                var _ret = _loop(idx);
                if (_ret === "break") break;
            }
        }
        return generatedBreadcrumbsArray;
    };
    var generateOrganizationBreadcrumbs = function(subPage) {
        return [
            baseBreadcrumbItem,
            {
                label: "organizations:home.title",
                link: "/hizmetler",
                isTranslatable: true
            }, 
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(subPage ? [
            subPage
        ] : []));
    };
    return {
        defaultBreadcrumbs: defaultBreadcrumbs,
        onlyTekneViaBreadcrumb: defaultBreadcrumbs[0],
        generateCategoryLinks: generateCategoryLinks,
        generateOrganizationBreadcrumbs: generateOrganizationBreadcrumbs
    };
}


/***/ }),

/***/ 55741:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85157);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(32852);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(88082);
// EXTERNAL MODULE: ./src/styles/TenderForm.module.css
var TenderForm_module = __webpack_require__(12775);
var TenderForm_module_default = /*#__PURE__*/__webpack_require__.n(TenderForm_module);
;// CONCATENATED MODULE: ./src/components/Organizations/TenderScreen/TenderAside.tsx




var TenderAside = function(param) {
    var wrapperClass = param.wrapperClass, isSwimmingOrganization = param.isSwimmingOrganization;
    var t = (0,useTranslation/* default */.Z)("organizations").t;
    var swimmingBullets = [
        "tenderForm.aside.bulletPoints.first",
        "tenderForm.aside.bulletPoints.second",
        "tenderForm.aside.bulletPoints.swimmingThird",
        "tenderForm.aside.bulletPoints.fourth", 
    ];
    var defaultBullets = [
        "tenderForm.aside.bulletPoints.first",
        "tenderForm.aside.bulletPoints.second",
        "tenderForm.aside.bulletPoints.defaultThird",
        "tenderForm.aside.bulletPoints.fourth", 
    ];
    var bulletPoints = isSwimmingOrganization ? swimmingBullets : defaultBullets;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("aside", {
        className: classnames_default()(wrapperClass, "mb-8 h-max space-y-4 bg-white"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "h-max space-y-6 rounded-md border p-6",
            children: bulletPoints.map(function(text, idx) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (TenderForm_module_default())["number-point-wrapper"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (TenderForm_module_default())["number-point"],
                            children: +idx + 1
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: t(text)
                        })
                    ]
                }, "points-".concat(idx));
            })
        })
    });
};
/* harmony default export */ var TenderScreen_TenderAside = (TenderAside);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
;// CONCATENATED MODULE: ./src/components/Organizations/TenderScreen/TenderFormTitle.tsx


var TenderFormTitle = function(param) {
    var title = param.title, description = param.description, useHeaderTag = param.useHeaderTag;
    var headerClasses = (0,react.useMemo)(function() {
        return "text-semibold text-2xl";
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mb-8",
        children: [
            useHeaderTag ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: headerClasses,
                children: title
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: headerClasses,
                children: title
            }),
            description ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mt-1 text-slate-500",
                children: description
            }) : null
        ]
    });
};
/* harmony default export */ var TenderScreen_TenderFormTitle = (TenderFormTitle);

// EXTERNAL MODULE: ./src/components/Seo/SeoWrapper.tsx + 1 modules
var SeoWrapper = __webpack_require__(15010);
// EXTERNAL MODULE: ./src/components/Vehicle/VehicleList/VehicleList.tsx
var VehicleList = __webpack_require__(75765);
// EXTERNAL MODULE: ./src/components/common/BBreadcrumb.tsx
var BBreadcrumb = __webpack_require__(73351);
// EXTERNAL MODULE: ./src/hooks/useBreadcrumbs.ts
var useBreadcrumbs = __webpack_require__(54865);
// EXTERNAL MODULE: ./src/hooks/useLocale.ts
var useLocale = __webpack_require__(74021);
// EXTERNAL MODULE: ./src/services/LocalizationService.ts
var LocalizationService = __webpack_require__(55389);
;// CONCATENATED MODULE: ./src/pages/hizmetler/[slug].tsx











var OrganizationDetail = function(param) {
    var title = param.title, description = param.description, slugs = param.slugs, slugTranslations = param.slugTranslations, availableVehicles = param.availableVehicles, content = param.content, helmetSettings = param.helmetSettings, isSwimmingOrganization = param.isSwimmingOrganization;
    LocalizationService/* localizationService.slugTranslations */.R.slugTranslations = (0,_object_spread/* default */.Z)({}, slugTranslations);
    var locale = (0,useLocale/* useLocale */.b)().locale;
    var generateOrganizationBreadcrumbs = (0,useBreadcrumbs/* useBreadcrumbs */.h)().generateOrganizationBreadcrumbs;
    var hasH1TitleOnSeoContent = (0,react.useMemo)(function() {
        return !!(content === null || content === void 0 ? void 0 : content.includes("</h1>"));
    }, [
        content
    ]);
    var breadcrumbs = generateOrganizationBreadcrumbs({
        isTranslatable: false,
        label: title,
        link: "/hizmetler/".concat(slugs[locale])
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SeoWrapper/* default */.Z, {
        content: content,
        helmetSettings: helmetSettings,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BBreadcrumb/* default */.Z, {
                breadcrumbItems: breadcrumbs,
                wrapperClasses: "mb-4"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TenderScreen_TenderFormTitle, {
                title: title,
                description: description,
                useHeaderTag: !hasH1TitleOnSeoContent
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TenderScreen_TenderAside, {
                isSwimmingOrganization: isSwimmingOrganization
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VehicleList/* default */.Z, {
                isThereMorePage: false,
                vehicles: availableVehicles,
                onPageChange: function() {
                    return {};
                }
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var _slug_ = (OrganizationDetail);


/***/ }),

/***/ 70379:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ getExperienceDurationByTime; }
/* harmony export */ });
/* harmony import */ var services_DateService__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49163);

function getExperienceDurationByTime(duration) {
    var dayjs = services_DateService__WEBPACK_IMPORTED_MODULE_0__/* .dateService.getDayjs */ .o.getDayjs();
    var d = dayjs.duration(duration, "m");
    return {
        hour: d.hours(),
        minute: d.minutes()
    };
}


/***/ }),

/***/ 97890:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"ExperienceCard_container__mL7aZ","image":"ExperienceCard_image__7tyRu","dash":"ExperienceCard_dash__rPXnr","star":"ExperienceCard_star__8HzwV"};

/***/ }),

/***/ 12775:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"form-doubled-layout":"TenderForm_form-doubled-layout__12az_","section-title":"TenderForm_section-title__YY_5y","section-subtitle":"TenderForm_section-subtitle__LE9v1","number-point-wrapper":"TenderForm_number-point-wrapper__dWzFA","number-point":"TenderForm_number-point__obbXt"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3457,5867,1643,9774,2888,179], function() { return __webpack_exec__(24337); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);